import { turkishCurrencyFormatterNoPrecision } from "../utils";

export default function CartScreenTouchItemRelativeForAnswer(props) {
  const { answer, cart, item, ozetle } = props;

  return (
    <div
      className="btn-group"
      style={{
        marginBottom: "0.3rem",
        marginLeft: "0.3rem",
        marginRight: "0.3rem",
      }}
    >
      {!ozetle && (item.customerName || cart.description) && (
        <div
          style={{
            height: "40px",
            width: "30px",
            overflow: "hidden",
          }}
        ></div>
      )}
      <div
        className="pe-2"
        style={{
          height: "40px",
          aspectRatio: "1/1",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          fontSize: "12px",
        }}
      >
        🥣
      </div>
      <div
        className="btn text-dark"
        style={{
          height: "40px",
          aspectRatio: "6/1",
          textAlign: "start",
          overflow: "hidden",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "baseline",
          borderBottom: "1px solid #ddd",
          borderRadius: "0px",
        }}
      >
        <div>
          <span
            className={
              item.isPartialPaid ? "textDecorationLine text-secondary" : ""
            }
          >
            {answer.answer}
          </span>
        </div>
        <div>
          {!!answer.cost && (
            <span
              className={
                item.isPartialPaid
                  ? "textDecorationLine text-bold text-secondary"
                  : item.isGift || cart.isStaffMeal
                  ? "isGift text-bold text-warning"
                  : "text-bold text-warning"
              }
            >
              {turkishCurrencyFormatterNoPrecision(answer.cost)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
